import { Partner } from "./reducer";
import { RequestStatus } from "../../request";

export type PartnerFetchFilterType = {
  hasAtLeastOneCampaign?: boolean;
};

export const FetchPartners = (
  limit: number = 10,
  offset: number = 0,
  filters: PartnerFetchFilterType = {}
) => {
  return {
    type: "partners-request-partners",
    limit,
    offset,
    filters,
  };
};

export const UpdatePartnersRequestStateAction = (
  requestState: RequestStatus
) => {
  return {
    type: "partners-update-request-state",
    requestState: requestState,
  };
};

export const UpdatePartners = (
  partners: Partner[],
  totalPartnersCount: number
) => {
  return {
    type: "partners-update-state",
    partners,
    totalPartnersCount,
  };
};
